if (!customElements.get('delivery-lead-time-message')) {
  customElements.define(
    'delivery-lead-time-message',
    class DeliveryLeadTimeMessage extends HTMLElement {
      constructor() {
        super();
        this.countdownContainer = this.querySelector('[data-order-countdown]');
        this.originalCountdownMessage = this.dataset.countdownMessage;
        this.orderPlacedContainer = this.querySelector('[data-order-placed]');
        this.orderDeliveredContainer = this.querySelector('[data-order-delivered]');
        this.rawData = document.querySelector('[data-lead-time-settings]');
        this.data = null;
        this.stockBannerContainer = this.closest('[data-stock-banner]');
        this.dateNow = new Date();
        this.nonDispatchDays = [];
        this.nonDispatchDates = [];

        this.timerInterval = null;
      }
      connectedCallback() {
        if (this.rawData == null) {
          return this.classList.add('hidden');
        }
        try {
          this.data = JSON.parse(this.rawData.innerText);
          this.calculate();
        } catch (e) {
          console.error(e);
          return this.classList.add('hidden');
        }
      }
      disconnectedCallback() {
        if (this.timerInterval != null) {
          clearInterval(this.timerInterval);
        }
      }
      getDayName(date) {
        return date.toLocaleDateString('en-gb', { weekday: 'short' });
      }
      getShopifyFormatDateString(date) {
        const month = (date.getMonth() + 1).toLocaleString('en-gb', { minimumIntegerDigits: 2, useGrouping: false });
        const day = date.getDate().toLocaleString('en-gb', { minimumIntegerDigits: 2, useGrouping: false });
        return `${date.getFullYear()}-${month}-${day}`;
      }
      getNextAvailableDispatchDate(dateObj) {
        while (
          this.nonDispatchDays.includes(this.getDayName(dateObj)) ||
          this.nonDispatchDates.includes(this.getShopifyFormatDateString(dateObj))
        ) {
          dateObj.setDate(dateObj.getDate() + 1);
        }
        return dateObj;
      }
      getNextAvailableDeliveryDay(dateObj) {
        while (
          this.nonDispatchDays.includes(this.getDayName(dateObj)) ||
          this.nonDeliveryDays.includes(this.getShopifyFormatDateString(dateObj)) ||
          this.nonDispatchDates.includes(this.getShopifyFormatDateString(dateObj))
        ) {
          dateObj.setDate(dateObj.getDate() + 1);
        }
        return dateObj;
      }
      renderCountdown() {
        let nextDispatchTime = new Date(this.dateNow.valueOf());
        nextDispatchTime.setHours(this.cutoffHour);
        nextDispatchTime.setMinutes(0);
        nextDispatchTime.setSeconds(0);
        let actualDateNow = new Date();
        if (nextDispatchTime.getDate() != actualDateNow.getDate()) {
          return this.countdownContainer.classList.add('hidden');
        }

        if (actualDateNow.getHours() >= nextDispatchTime.getHours()) {
          return this.countdownContainer.classList.add('hidden');
        }

        let timeDiff = this.timeRemaining(nextDispatchTime);
        let countdownMessage = this.buildCountdownString(timeDiff);
        this.countdownContainer.innerHTML = this.originalCountdownMessage.replace('[countdown]', countdownMessage);

        this.timerInterval = setTimeout(() => this.renderCountdown(), 1000);
      }
      buildCountdownString(time) {
        let countdownMessage = '';
        countdownMessage = `<span class='countdown-number'>
        ${time.h > 0 ? `${time.h} ${time.h == 1 ? 'hour' : 'hours'},` : ''}
         ${time.m > 0 ? `${time.m} ${time.m == 1 ? 'minute' : 'minutes'},` : ''}
        ${time.s} ${time.s == 1 ? 'second' : 'seconds'}
        </span>`;

        return countdownMessage;
      }
      timeRemaining(deadline) {
        let dateNow = new Date();
        let t = deadline - dateNow.valueOf();
        let days = Math.floor(t / (1000 * 60 * 60 * 24));
        let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((t % (1000 * 60)) / 1000);
        return {
          t: t,
          d: days,
          h: hours,
          m: minutes,
          s: seconds,
        };
      }
      async calculate() {
        if (this.stockBannerContainer.dataset.country == null) {
          let response = await fetch(`/browsing_context_suggestions.json`);
          let data = await response.json();
          let country = data.detected_values.country.handle;
          this.stockBannerContainer.dataset.country = country;
        }
        let country = this.stockBannerContainer.dataset.country;
        //let international = country == 'GB';
        let international = country == 'GB' ? false : true;
        const { cutoffHour, minimumLeadDays, maximumLeadDays, internationalLeadTime } = this.data.leadTimeSettings;
        const { days, dates } = this.data.nonDispatchDays;
        const { days: nonDeliveryDays } = this.data.nonDeliveryDays;
        this.nonDispatchDays = days;
        this.nonDispatchDates = dates;
        this.nonDeliveryDays = nonDeliveryDays;
        this.cutoffHour = parseInt(cutoffHour);
        //if after the cutoff
        //add a day to the current day
        if (this.dateNow.getHours() >= this.cutoffHour) {
          this.dateNow.setDate(this.dateNow.getDate() + 1);
        }
        this.dateNow = this.getNextAvailableDispatchDate(this.dateNow);

        this.renderCountdown();

        let firstAvailableDeliveryDate = new Date(this.dateNow.valueOf());
        let firstAddition = international
          ? parseInt(minimumLeadDays) + parseInt(internationalLeadTime)
          : parseInt(minimumLeadDays);
        firstAvailableDeliveryDate.setDate(firstAvailableDeliveryDate.getDate() + firstAddition);
        firstAvailableDeliveryDate = this.getNextAvailableDeliveryDay(firstAvailableDeliveryDate);

        let maxAvailableDeliveryDate = new Date(firstAvailableDeliveryDate.valueOf());
        let maxAddition = international
          ? parseInt(maximumLeadDays) - parseInt(minimumLeadDays) + parseInt(internationalLeadTime)
          : parseInt(maximumLeadDays) - parseInt(minimumLeadDays);
        maxAvailableDeliveryDate.setDate(maxAvailableDeliveryDate.getDate() + maxAddition);
        maxAvailableDeliveryDate = this.getNextAvailableDeliveryDay(maxAvailableDeliveryDate);
        const outputDateOptions = {
          month: 'short',
          day: 'numeric',
        };
        this.orderPlacedContainer.innerHTML = `
           <span class='date'>${new Date().toLocaleDateString('en-gb', outputDateOptions)}</span>
           Order Placed
        `;

        this.orderDeliveredContainer.innerHTML = ` <span class='date'>${firstAvailableDeliveryDate.toLocaleDateString(
          'en-gb',
          outputDateOptions
        )} -  ${maxAvailableDeliveryDate.toLocaleDateString('en-gb', outputDateOptions)}</span>
            Delivered
        `;

        this.classList.remove('hidden');
      }
    }
  );
}
